import { OLDYUP as YUP } from 'utils'
import { isValidCNPJ, isValidCPF } from 'utils/functions'
import * as yup from 'yup'

export const SCHEMA = {
  noSapContractForm: yup
    .object({
      CRE: yup
        .string()
        .typeError('CRE obrigatório')
        .required('CRE obrigatório'),
      cdContrato: yup
        .string()
        .required('Contrato obrigatório')
        .test(
          'invalidQSC',
          'O código do contrato não pode conter Q ou SC',
          (x) => {
            return (
              !x?.toLowerCase().includes('q') &&
              !x?.toLowerCase().includes('sc')
            )
          }
        ),
      // cdGrupoMercadoria: yup
      //   .string()
      //   .required('Grupo Mercadoria obrigatório')
      //   .typeError('Grupo Mercadoria obrigatório'),
      // cdHierarquiaProd: yup
      //   .string()
      //   .required('Hierarquia Produto obrigatório')
      //   .typeError('Hierarquia Produto obrigatório'),
      centroPlantaId: yup
        .number()
        .required('Centro Planta obrigatório')
        .typeError('Centro Planta obrigatório'),
      cnpj: yup
        .string()
        .required('Informe CPF / CNPJ / Cód. Fornecedor')
        .max(18, 'CNPJ Inválido'),
      // descGrupoMercadoria: yup
      //   .string()
      //   .required('Grupo Mercadoria obrigatório')
      //   .typeError('Grupo Mercadoria obrigatório'),
      // descHierarquiaProduto: yup
      //   .string()
      //   .required('Hierarquia Produto obrigatório')
      //   .typeError('Hierarquia Produto obrigatório'),
      emailsTrabalhistas: yup.array().min(1, 'Informe pelo menos um E-mail'),
      empresa: yup.string().required('Empresa obrigatória'),
      matriculaContraparte: yup.string().required('Contraparte obrigatório'),
      nmContraparte: yup.string().required('Contraparte obrigatório'),
      setorId: yup
        .number()
        .required('Negócio obrigatório')
        .typeError('Negócio Obrigatório'),
      txAlerta: yup.string().when('flAlerta', {
        is: true,
        then: yup
          .string()
          .required(
            'Opção de alerta selecionada mas nenhuma justificativa inserida'
          )
      }),
      txDenuncia: yup.string().when('flDenuncia', {
        is: true,
        then: yup
          .string()
          .required(
            'Opção de denúncia selecionada mas nenhuma justificativa inserida'
          )
      }),
      txObjetoContrato: yup.string().required('Objeto do Contrato obrigatório'),
      vlContratual: yup.string().required('Valor contratual obrigatório')
    })
    .concat(YUP.dateRange('dtVigenciaInicio', 'dtVigenciaFim').required)
    .concat(YUP.dateRange('dtVigInicoReal', 'dtVigFimReal').oneRequireAnother)
}
